import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { Cell } from '../grid/Cell'
import { XCircleIcon } from '@heroicons/react/outline'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const AboutGame = ({ isOpen, handleClose }: Props) => {
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-10 inset-0 overflow-y-auto"
        onClose={handleClose}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
              <div className="absolute right-4 top-4">
                <XCircleIcon
                  className="h-6 w-6 cursor-pointer"
                  onClick={() => handleClose()}
                />
              </div>
              <div>
                <div className="text-justify">
                  <Dialog.Title
                    as="h3"
                    className="text-lg leading-6 font-medium text-gray-900"
                  >
                    Wordle
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                    Wordle, əvvəllər Reddit üçün Place və The Button sosial təcrübələrini yaradan proqramçı Coş Uordl tərəfindən hazırlanmış veb əsaslı söz oyunudur. Beş hərfli sözü oyunçular altı cəhddə təxmin etməyə çalışırlar; Hər bir təxminə rəngli qutular şəklində rəy verilir və oyunçulara cavab sözündə hansı hərflərin düzgün və hansının digər mövqelərdə olduğu bildirilir. Bu cür oyun mexanikası Mastermind kimi oyunlara bənzəyir, lakin Wordle hər bir təxmində hansı hərflərin düzgün olduğunu dəqiq müəyyənləşdirir. Hər gün və hər kəs üçün eyni olan xüsusi bir cavab sözü var.
                    </p>
                    <p className="text-sm text-gray-500">
                    Uordl oyunu əvvəlcə yalnız özü və sevgilisi üçün hazırlamışdı. Oyun, 2021-ci ilin oktyabrında ictimaiyyətə təqdim edilmişdir. Uordl oyuna gündəlik nəticələri Twitter -də geniş şəkildə paylaşılan emoji kvadratları kimi kopyalamaq imkanı əlavə etdikdən sonra oyun 2021-ci ilin dekabrında kütləvi populyarlıq qazandı. Oyunun ingilis dilindən başqa dillərdə çoxlu nüsxələri, uyğunlaşdırmaları və versiyaları da yaradılmışdır. Oyun 2022-ci ilin yanvarında açıqlanmayan yeddi rəqəmli məbləğə The New York Times şirkəti tərəfindən alınıb və əvvəlcə bütün oyunçular üçün pulsuz saxlanması planlaşdırılıb.
                    </p>
                    
                  </div>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
